<template>
  <div>
    <div v-if="$estimate()">
      <div :class="{ nav: !isfixed, headfixed: isfixed }">
        <div class="head_container">
          <h1>
            <router-link to="/"><img :src="this.$URL + 'image/logo.png'" class="head_container_img" /></router-link>
          </h1>
          <!-- 导航右边 -->
          <div>
            <div style="font-size: 1.8em;position: relative;padding: 0 1em;" @click="isMenu = !isMenu">
              <i class="el-icon-s-unfold"></i>
            </div>
            <ul class="header-nav-wrapper" v-if="isMenu">
              <li v-for="(item, index) in navListMoth" :key="index" :class="index == navIndex ? 'active' : ''"
                @click="navClick(index, item.name)">
                <router-link :to="item.path">
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- 导航栏 -->
      <div :class="{ nav: !isfixed, headfixed: isfixed }">
        <div class="head_container">
          <div style="padding-left: 40px; padding-top: 6px">
            <h1>
              <router-link to="/"><img :src="this.$URL + 'image/logo.png'" /></router-link>
            </h1>
          </div>
          <!-- 导航右边 -->
          <ul class="header-nav-wrapper">
            <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item.name)">
              <router-link :to="item.path">
                {{ item.name }}
                <span v-if="item.children.length > 0" class="glyphicon el-icon-arrow-down"></span>
                <i class="underline"></i>
              </router-link>
              <dl v-if="item.children.length > 0">
                <dt v-for="(i, n) in item.children" :key="n">
                  <router-link :to="i.path">{{ i.name }}</router-link>
                </dt>
              </dl>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerView",
  data() {
    return {
      isMenu: false,
      isfixed: false,
      navIndex: 0,
      navListMoth: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "公司简介",
          path: "/intro",
        },
        // ============================
        {
          name: "AMR机器人",
          path: "/robot",
        },
        {
          name: "换电产品",
          path: "/battery",
        },
        {
          name: "储能产品",
          path: "/energy",
        },
        // ==============================
        {
          name: "合作车型",
          path: "/motorcycle",
        },
        {
          name: "分布式微电网",
          path: "/microgrid",
        },
        {
          name: "新闻中心",
          path: "/journalism",
        },
        {
          name: "商务合作",
          path: "/business",
        },
        {
          name: "公司招聘",
          path: "/engage",
        }
      ],
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "公司简介",
          path: "/intro",
          children: [],
        },
        {
          name: "公司产品",
          path: "",
          children: [
            {
              name: "AMR机器人",
              path: "/robot",
            },
            {
              name: "换电产品",
              path: "/battery",
            },
            {
              name: "储能产品",
              path: "/energy",
            }
          ],
        },
        {
          name: "产品应用",
          path: "",
          children: [
            {
              name: "合作车型",
              path: "/motorcycle",
            },
            {
              name: "分布式微电网",
              path: "/microgrid",
            }
          ],
        },
        {
          name: "新闻中心",
          path: "/journalism",
          children: [],
        },
        {
          name: "联系我们",
          path: "",
          children: [
            {
              name: "商务合作",
              path: "/business",
            },
            {
              name: "公司招聘",
              path: "/engage",
            }
          ]
        },
      ],
    };
  },
  watch: {
    $route: function (val, old) {
      if (this.$estimate() && val.path != old.path) {
        this.isMenu = false;
        switch (val.path) {
          case "/":
            this.navIndex = 0;
            sessionStorage.setItem("navIndex", 0);
            break;
          case "/intro":
            this.navIndex = 1;
            sessionStorage.setItem("navIndex", 1);
            break;
          // ==============================
          case "/robot":
            this.navIndex = 2;
            sessionStorage.setItem("navIndex", 2);
            break;
          case "/battery":
            this.navIndex = 3;
            sessionStorage.setItem("navIndex", 3);
            break;
          case "/energy":
            this.navIndex = 4;
            sessionStorage.setItem("navIndex", 4);
            break;
          // =================================
          case "/motorcycle":
            this.navIndex = 5;
            sessionStorage.setItem("navIndex", 5);
            break;
          case "/microgrid":
            this.navIndex = 6;
            sessionStorage.setItem("navIndex", 6);
            break;
          case "/journalism":
            this.navIndex = 7;
            sessionStorage.setItem("navIndex", 7);
            break;
          case "/business":
            this.navIndex = 8;
            sessionStorage.setItem("navIndex", 8);
            break;
          case "/engage":
            this.navIndex = 9;
            sessionStorage.setItem("navIndex", 9);
            break;
          default:
            this.navIndex = 0;
            sessionStorage.setItem("navIndex", 0);
        }
      } else {
        switch (val.path) {
          case "/":
            this.navIndex = 0;
            sessionStorage.setItem("navIndex", 0);
            break;
          case "/sitePage":
            this.navIndex = 0;
            sessionStorage.setItem("navIndex", 0);
            break;
          case "/intro":
            this.navIndex = 1;
            sessionStorage.setItem("navIndex", 1);
            break;
          // =======================================
          case "/robot":
            this.navIndex = 2;
            sessionStorage.setItem("navIndex", 2);
            break;
          case "/battery":
            this.navIndex = 2;
            sessionStorage.setItem("navIndex", 2);
            break;
          case "/energy":
            this.navIndex = 2;
            sessionStorage.setItem("navIndex", 2);
            break;
          // =======================================
          case "/motorcycle":
            this.navIndex = 3;
            sessionStorage.setItem("navIndex", 3);
            break;
          case "/microgrid":
            this.navIndex = 3;
            sessionStorage.setItem("navIndex", 3);
            break;
          case "/journalism":
            this.navIndex = 4;
            sessionStorage.setItem("navIndex", 4);
            break;
          case "/business":
            this.navIndex = 5;
            sessionStorage.setItem("navIndex", 5);
            break;
          case "/engage":
            this.navIndex = 5;
            sessionStorage.setItem("navIndex", 5);
            break;
          case "/needDetail":
            this.navIndex = 5;
            sessionStorage.setItem("navIndex", 5);
            break;
          default:
            this.navIndex = 0;
            sessionStorage.setItem("navIndex", 0);
        }
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var sctop = document.documentElement.scrollTop || document.body.scrollTop;
      //防抖操作
      if (sctop > 60) {
        this.isfixed = true;
      } else {
        this.isfixed = false;
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    }
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .glyphicon {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: "Glyphicons Halflings";
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  @keyframes headscroll {
    0% {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 99;
      opacity: 0;
    }

    100% {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 99;
      opacity: 1;
    }
  }

  .nav_list>span>a {
    color: #212c48;
  }

  .nav_warp .nav_list {
    margin-left: 70px;
    margin-top: 20px;
  }

  .nav_warp {
    max-width: 1160px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-content: center;
    text-align: center;
  }

  .nav_warp {
    max-width: 1160px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-content: center;
    text-align: center;
    justify-content: right;
    margin-right: 20px;
    padding-top: 6px;
  }

  .nav {
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  .header-nav-wrapper {
    line-height: 2.3em;
    padding: 0 1em;
    position: absolute;
    top: 3.5em;
    right: 1px;
    border-radius: 5px;
    box-shadow: 0 0 3px 1px #ccc;
    background: #f8f8f8;
    animation: bounceInLeft 0.3s;
  }

  @keyframes bounceInLeft {
    0% {
      transform: translate3d(5rem, 0, 0);
    }

    60% {
      transform: translate3d(0.5rem, 0, 0);
    }

    75% {
      transform: translate3d(0.1rem, 0, 0);

    }

    90% {

      transform: translate3d(0em, 0, 0);
    }

    100% {
      transform: none;
    }
  }

  .header-nav-wrapper>li>a {
    color: #333333;
    font-size: 1em;
    padding: 0.5em 0;
  }

  .header-nav-wrapper>li>a>i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #077af1;
  }

  .header-nav-wrapper>li>a>span {
    font-size: 14px;
    transition: transform ease 0.5s;
  }

  .header-nav-wrapper>li.active>a {
    color: #077af1;
    text-decoration: none;
    border-bottom: 2px solid #077af1;
  }

  .header-nav-wrapper>li>dl {
    display: block;
  }

  .header-nav-wrapper>li>dl>dt {
    line-height: 30px;
  }

  .header-nav-wrapper>li>dl>dt>a {
    color: #333333;
  }

  .head_container {
    display: flex;
    padding: .8em 1em;
    background: #f3f3f3;
    align-items: center;
    justify-content: space-between;
  }

  .head_container_img {
    width: 80%;
  }
}

@media screen and (min-width: 1200px) {
  .head_container {
    padding: 0 200px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    justify-content: space-between;
  }

  .glyphicon {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: "Glyphicons Halflings";
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .headfixed {
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3) !important;
    animation: headscroll 0.8s alternate;
    animation-fill-mode: forwards;
  }

  @keyframes headscroll {
    0% {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 99;
      opacity: 0;
    }

    100% {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 99;
      opacity: 1;
    }
  }

  .nav_list>span>a {
    color: #212c48;
  }

  .nav_warp .nav_list {
    margin-left: 70px;
    margin-top: 20px;
  }

  .nav_warp {
    max-width: 1160px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-content: center;
    text-align: center;
  }

  .nav_warp {
    max-width: 1160px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-content: center;
    text-align: center;
    justify-content: right;
    margin-right: 20px;
    padding-top: 6px;
  }

  .nav {
    height: 60px;
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
  }

  .header-nav-wrapper {
    line-height: 50px;
  }

  .header-nav-wrapper {
    margin: 0;
    max-width: 800px;
  }

  .header-nav-wrapper>li {
    float: left;
    margin: 0 25px;
    position: relative;
  }

  .header-nav-wrapper>li>a {
    color: #313b57;
    font-size: 16px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  .header-nav-wrapper>li>a>i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #077af1;
  }

  .header-nav-wrapper>li>a>span {
    font-size: 14px;
    transition: transform ease 0.5s;
  }

  .header-nav-wrapper>li>a:hover {
    color: #313b57;
    text-decoration: none;
  }

  .header-nav-wrapper>li>a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }

  .header-nav-wrapper>li>a:hover span {
    transform: rotate(180deg);
  }

  .header-nav-wrapper>li.active>a {
    color: #077af1;
    text-decoration: none;
    border-bottom: 2px solid #077af1;
  }

  .header-nav-wrapper>li>dl {
    display: none;
    position: absolute;
    width: 168px;
    top: 95%;
    left: 0;
    z-index: 999999;
    box-shadow: 0 0 3px 1px #ccc;
    background: #fff;
    border-radius: 3px;
  }

  .header-nav-wrapper>li>dl>dt {
    padding: 10px;
    line-height: 30px;
  }

  .header-nav-wrapper>li>dl>dt>a {
    color: #313b57;
    padding: 8% 27% 8% 0;
  }

  .header-nav-wrapper>li>dl>dt>a:hover {
    text-decoration: none;
  }

  .header-nav-wrapper>li:hover dl {
    display: block;
  }

  .header-nav-wrapper>li>dl>dt:hover {
    cursor: pointer;
    background: #077af1;
  }

  .header-nav-wrapper>li>dl>dt:hover>a {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue